var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22723_239929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 6.2487C1.66669 6.2487 2.08335 5.83203 3.33335 5.83203C4.58335 5.83203 5.41669 6.66536 6.66669 6.66536C7.91669 6.66536 8.33335 6.2487 8.33335 6.2487V1.2487C8.33335 1.2487 7.91669 1.66536 6.66669 1.66536C5.41669 1.66536 4.58335 0.832031 3.33335 0.832031C2.08335 0.832031 1.66669 1.2487 1.66669 1.2487V6.2487Z",
    stroke: "#2B7FFF",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 9.16667V6.25",
    stroke: "#2B7FFF",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22723_239929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.3d3847e62e4ee8770f3b634e76e7ed31.svg";
export { ForwardRef as ReactComponent };